<template>
    <div class="bg-white text-gray-900 tile h-full flex items-center justify-center">
        <div class="p-12 mx-auto font-bold">
            <div class="text-3xl pb-5 text-center">{{ value | toCurrency }}</div>
            <div class="text-center whitespace-nowrap">{{$t('pages.dashboard.components.floor_sales_today.label')}}</div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';


export default {
    layout: Layout,
    props: {
        value: Number
    }
}
</script>
